import React from "react";
import TaxDetailsList from "./TaxDetailsList";
import NavHeightAdjust from "../../../../components/navbar/NavHeightAdjust";

const SalesPerson = () => {
  return (
    <NavHeightAdjust>
      <TaxDetailsList />
    </NavHeightAdjust>
  );
};

export default SalesPerson;
